import { ButtonHTMLAttributes, ReactElement, forwardRef } from 'react';

import styled from 'styled-components';

import { IconButton } from '@components/icon-button';
import { IconProps } from '@components/icons';
import { pxToRem } from '@utils/converters';

import { IconDrag } from '../icons/drag';

export type DragHandleProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  icon?: ReactElement<IconProps>;
};

export const SmallDragHandle = forwardRef<HTMLButtonElement, DragHandleProps>((props, ref) => {
  return (
    <HandleButton
      ref={ref}
      data-slot="drag-handle"
      dataTestid="small-drag-handle"
      variant="ghost-purple"
      size="sm"
      cursor="grab"
      stopPropagation
      preventDefault
      icon={<IconDrag />}
      {...props}
    />
  );
});

const HandleButton = styled(IconButton)({
  height: pxToRem(24),
  width: pxToRem(24),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  zIndex: 1,
  '&[data-variant="ghost"]:not(:disabled):hover, &[data-variant="ghost"]:not(:disabled):active': {
    backgroundColor: 'transparent',
  },
});
